import { useContext } from "react";
import SettingsContext from "src/contexts/settings/SettingsContext";

const useSettings = () => useContext(SettingsContext);

export default useSettings;
